import React, { useCallback, useContext } from "react";
import cbImage from "../../images/CB.png";
import embLabels from "../../config/emb-labels-en.json";
import Tooltip from "../../utils/Tooltip";
import { useSelector } from "react-redux";

import useProjectTypeValue from "../../utils/useCurrentProjectValue";
import LoadCbContactorDetails from "./LoadCbContactorDetails";

const LoadCB = ({ detailsBlock, loadData = {} }) => {
  const {
    siteType,
    configData,
    handleCBConfigChangeLoad,
    assetEditStatusUpdateLoadCb,
    selectedValues,
    setAssetSelection,
    CBLoadList,
    assetDetailsDisplay,
    projectKind,
  } = loadData ;
  // const {configData,cbConfigData} = loadData?.CBLoadList[selectedValues?.selectedLoad];
  const projectType = useProjectTypeValue();
  const tooltipData = useSelector((state) => state?.tooltipData?.tooltipData);
  const loadCbConfigChangeHandler = (e) => {
    handleCBConfigChangeLoad?.(e);
    assetEditStatusUpdateLoadCb?.(e, true, selectedValues?.selectedLoad);
  };
  const contactorChangeHandler = (e) => {
    handleCBConfigChangeLoad?.(e);
    assetEditStatusUpdateLoadCb?.(e, true, selectedValues?.selectedLoad);
  };
  const setAssetHandler = () => setAssetSelection?.(embLabels.CIRCUIT_BREAKER);
  const checked = useCallback(() => {
    if (CBLoadList?.[selectedValues?.selectedLoad]?.uiData?.contactor) {
      return true;
    } else {
      return false;
    }
  }, [CBLoadList]);
  const assetInfo =
    CBLoadList?.[selectedValues?.selectedLoad]?.cbConfigData?.cbAssetDetails?.[0]
      ?.assetInfo;
  const isMotorisedDisbaled = assetInfo === "Hardwired";

  return (
    <div name="Circuit_Breaker" className="col-md-12 p-0">
      {/* <div className="col-md-12 pt-2 se-white-background">
        <div className="row">
          <div className="col-md-8">
            <img
              src={
                CBLoadList[selectedValues?.selectedLoad]?.cbConfigData
                  .cbAssetDetails[0]?.imageLink === null
                  ? cbImage
                  : CBLoadList[selectedValues?.selectedLoad]?.cbConfigData
                      .cbAssetDetails[0]?.imageLink
              }
              className="asset-image-icon"
              alt="circuit breaker"
            />
            <span className="align-top line-height-30px bold">
              Circuit Breaker
            </span>
          </div>
        </div>
      </div> */}
      <div className="col-sm-12 bold mt-2 mb-2">Circuit Breaker</div>
      <div className="col-md-12 col-sm-12 pt-2 pb-2 se-grey-background se-border">
        <div className="row">
          <div className="col-md-3">
            <img
              src={
                CBLoadList?.[selectedValues?.selectedLoad]?.cbConfigData?.cbAssetDetails?.[0]?.imageLink === null
                  ? cbImage
                  : CBLoadList?.[selectedValues?.selectedLoad]?.cbConfigData
                      .cbAssetDetails?.[0]?.imageLink
              }
              className="asset-image-display"
              alt="circuit breaker"
            />
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12 bold text-uppercase">
                Schneider Electric
              </div>
              <div className="col-md-12">
                {assetDetailsDisplay?.communicationModel ||
                  CBLoadList?.[selectedValues?.selectedLoad].cbConfigData?.cbAssetDetails?.[0]?.assetInfo ||
                  "PowerPact NSX"}
                <Tooltip
                  position="right"
                  iconColor="secondary"
                  information={
                    assetDetailsDisplay?.communicationModel ||
                    CBLoadList?.[selectedValues?.selectedLoad].cbConfigData?.cbAssetDetails?.[0]?.communicationModel ||
                    "PowerPact NSX"
                  }
                />
              </div>
            </div>
          </div>

          <div
            className=" col-md-3 col-sm-3 col-lg-3 text-center d-flex align-items-center"
            style={
              siteType === embLabels.GENSET_PVBESS_A2E
                ? { display: "none" }
                : {}
            }
          >
            <se-button option="outline" size="small" onClick={setAssetHandler}>
              Asset Selection
            </se-button>
          </div>
        </div>
      </div>
      {/* 
      <div className="col-md-12 mt-2 se-white-background align-middle">
        <div className="row mb-2">
          <label className=" col-md-5 mt-2 bold se-font-14px pt-1">
            Asset Settings
          </label>

          <div className="col-md-7 mt-1 text-right">
            <button
              type="button"
              className="btn btn-secondary btn-sm se-btn-secondary"
              // onClick={updateLoadCbConfigData}
              onClick={updateLoadCbPm}
            >
              <se-icon size="nano">action_save</se-icon>
              <span>&nbsp;</span>Save Settings
            </button>
          </div>
        </div>
      </div> */}
      <div className="col-md-12 se-grey-background pb-2">
        <div className="form-group mb-1 mt-2">
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput1"
            placeholder="Name"
            name="name"
            value={configData?.cbConfigData?.name}
            onChange={loadCbConfigChangeHandler}
          />

          <div
            className="invalid-feedback-custom"
            style={!configData?.cbConfigData?.name ? {} : { display: "none" }}
          >
            {embLabels.nameRequired}
          </div>
          {(projectType === "DaaS ANSI" || projectType === "DaaS ETO") && (
            <div
              className="invalid-feedback-custom"
              style={
                configData?.cbConfigData?.name !== "" &&
                !/^[a-z0-9-_]+$/.test(configData?.cbConfigData?.name)
                  ? {}
                  : { display: "none" }
              }
            >
              {"Invalid Name"}
            </div>
          )}
        </div>

        <div className="form-group mb-1">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input asCompatible"
              name="motorized"
              id="customControlValidation4"
              onChange={loadCbConfigChangeHandler}
              value={configData?.cbConfigData?.motorized}
              checked={configData?.cbConfigData?.motorized}
            />
            <label
              className="custom-control-label line-height-25"
              htmlFor="customControlValidation4"
            >
              Motorized Circuit Breaker
            </label>
            {configData?.cbConfigData?.motorized}
            <Tooltip
              position="right"
              iconColor="secondary"
              iconSize="small"
              information={tooltipData?.motorized?.data}
            />
          </div>
        </div>

        {isMotorisedDisbaled &&
          (projectKind?.isMgaasIec || projectKind?.isMGaaSETO) &&
          !projectKind?.isMGaaSETO && (
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input asCompatible"
                name="contactor"
                id="customControlValidation45"
                value={checked()}
                checked={checked()}
                onChange={contactorChangeHandler}
              />
              <label
                className="custom-control-label line-height-25"
                htmlFor="customControlValidation45"
              >
                Circuit Breaker + Contactor
              </label>
            </div>
          )}

        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">Description</label>
          <input
            type="text"
            autoComplete="none"
            className="form-control form-control-sm"
            id="exampleFormControlInput1"
            placeholder="Description"
            name="description"
            value={configData?.cbConfigData?.description}
            onChange={loadCbConfigChangeHandler}
          />
        </div>
      </div>
      {!projectKind?.isMGaaSETO &&
        CBLoadList?.[selectedValues?.selectedLoad]?.uiData?.contactor &&
        isMotorisedDisbaled && (
          <LoadCbContactorDetails
            detailsBlock={detailsBlock}
            loadData={loadData}
          />
        )}
    </div>
  );
};

export default LoadCB;
